import 'es6-promise/auto';
import * as React from 'react';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import PerformanceAddonsDisplay from './performance-addons-display';
import { PerformanceViewModel, ReserveRequest, IProductionModels} from './classes';
import { performanceDispatch } from './performance-addons';
import { initializePerformances, ActionTypes } from './actions';


declare const productionList: Array<PerformanceViewModel>;

let locationUrl = document.location.origin;

interface PerformanceAddonsContainerState {
    productionModels: IProductionModels;
    productionNames: Array<string>;
}

class PerformanceAddonsContainer extends React.Component<IProductionModels, PerformanceAddonsContainerState>{
    constructor(props) {
        super(props)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setToDefault = this.setToDefault.bind(this);
        this.state = {
            productionModels: this.addGuid(this.props),
            productionNames: []
        }
    }


    componentWillReceiveProps(props) {
        if (props !== this.props) {
            this.setState({
                productionModels: this.addGuid(props)
            })
        }
    }

    guid(): string {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    addGuid(productionModel: IProductionModels): IProductionModels {
        var perfModel = productionModel.performanceModels;
        for (let i = 0; i < perfModel.length; i++) {
            if (perfModel[i].guid == "" || perfModel[i].guid == undefined)
                perfModel[i].guid = this.guid();
        }
        return productionModel;
    }

    handleSubmit(e): void {
        e.preventDefault();
        var productionModels = this.state.productionModels;
        this.reserveAddons(productionModels);
    }

    reserveAddons(request: IProductionModels): void {
        let reserveUrl = locationUrl + "/PerformanceAddons/ReservePerformances";
        fetch(reserveUrl,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                body: JSON.stringify({
                    reserveRequests: request
                }),
                credentials: 'same-origin',
            }).then(response => {
                if (response.status === 200) {
                    response.json().then(results => {
                        this.afterReserve(results);
                    })
                }
            })
            .catch(error => {
                console.error(error);
            });
    }

    afterReserve(request: IProductionModels): void {
        if (!request.reserveFail) {
            window.location.href = request.redirectUrl
        } else {
            this.initializeFailedProductions(request);
        }
    }

    setFailedProductions(request: IProductionModels) {
        var productionNames = [];
        request.performanceModels.forEach((value) => {
            productionNames.push(value.productionName);
        })
        this.setState({
            productionNames: productionNames
        })
    }

    initializeFailedProductions(request: IProductionModels) {
        var productionModel = (JSON.parse(JSON.stringify((window as any).bootStrappedData)) as IProductionModels);
        var performanceModel = productionModel.performanceModels;
        var requestPerfModel = request.performanceModels;
        var performanceToAdd = [];
        for (var i = 0; i < performanceModel.length; i++) {
            let contains = false;
            for (var j = 0; j < requestPerfModel.length; j++) {
                if (requestPerfModel[j].productionId === performanceModel[i].productionId) {
                    contains = true;
                }
            }
            if (!contains) {
                performanceToAdd.push(performanceModel[i]);
            }
        }

        performanceToAdd.forEach(perf => {
            request.performanceModels.push(this.setToDefault(perf));
        })
        performanceDispatch()(initializePerformances(request));
    }

    setToDefault(model: PerformanceViewModel): PerformanceViewModel {
        var perfModel = (JSON.parse(JSON.stringify(model)) as PerformanceViewModel);
        perfModel.performanceId = 0;
        perfModel.zoneId = 0;
        perfModel.quantity = 0;
        return perfModel;
    }

    cancelButtonCall(e: any) {
        window.location.href = this.state.productionModels.redirectUrl;
    }

    render()
    {
        return (
            <div className="addons-container">
                <div className="addons-container-inner">
                <form onSubmit={this.handleSubmit}>
                    <h3 dangerouslySetInnerHTML={{ __html: this.state.productionModels.title }} />
                    <p dangerouslySetInnerHTML={{ __html: this.state.productionModels.subHeading }} />
                    {
                        (this.props.reserveFail) ?
                            (<div>
                                {
                                    this.state.productionNames.map((name) => {
                                        return <p>value</p>
                                    })
                                }
                            </div>):
                            (<div></div>)
                    }
                    <PerformanceAddonsDisplay productions={this.state.productionModels.performanceModels as Array<PerformanceViewModel>} />
                        <button type="submit">Reserve</button>
                        <button className="btn-secondary" type="button" onClick={this.cancelButtonCall.bind(this)}>Cancel</button>
                    </form>
                </div>
            </div>
        );
    }
}
export default connect((state) => state)(PerformanceAddonsContainer);